import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRedirectAuthResult } from '@/lib/firebase';

/**
 * Handles return from signInWithRedirect (e.g. from extension or email links).
 * Redirect result is processed in App useEffect; this route can show loading
 * or redirect to dashboard once auth state is set.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');

  useEffect(() => {
    getRedirectAuthResult()
      .then((result) => {
        if (result?.user) {
          setStatus('ok');
          navigate('/', { replace: true });
        } else {
          setStatus('error');
          setTimeout(() => navigate('/auth', { replace: true }), 2000);
        }
      })
      .catch(() => {
        setStatus('error');
        setTimeout(() => navigate('/auth', { replace: true }), 2000);
      });
  }, [navigate]);

  const loadingClass = 'flex min-h-screen items-center justify-center bg-mirror-bg text-mirror-muted text-lg';
  if (status === 'loading') return <div className={loadingClass}>Completing sign-in…</div>;
  if (status === 'error') {
    return (
      <div className={loadingClass}>
        <p>Sign-in could not be completed. Redirecting to sign-in…</p>
      </div>
    );
  }
  return <div className={loadingClass}>Redirecting…</div>;
}
